import { createEnum } from "@redotech/zod/zod-enum";
import * as z from "zod/v4";

export const getAskRedoThreads = {
  name: "getAskRedoThreads" as const,

  input: z.object({
    agentNames: z.array(z.string()),
    searchQuery: z.string().optional(),
    calledAgentFilter: z.string().optional(),
    escalationFilter: createEnum(["yes", "no"]).optional(),
    channelTypeFilter: createEnum([
      "general",
      "support",
      "ask-redo",
    ]).optional(),
    sourceFilter: createEnum([
      "slack",
      "ai-draft",
      "ai-draft-slack",
      "ai-draft-intercom",
      "email",
    ]).optional(),
    dateRange: z
      .object({ start: z.date().nullable(), end: z.date().nullable() })
      .optional(),
    page: z.number().min(1).default(1),
    pageSize: z.number().min(1).max(100).default(20),
    internal: z.boolean().optional(),
    skipEmailFilter: z.boolean().optional(),
    teamIdFilter: z.string().optional(),
    attemptedIntercomConversationIds: z.array(z.string()).optional(),
    excludeThreadSources: z.array(z.string()).optional(),
    toolFilter: z.string().optional(),
    subcategoryFilter: z.array(z.string()).optional(),
  }),

  output: z.object({
    data: z.array(
      z.object({
        _id: z.string(),
        agentName: z.string(),
        teamId: z.string().optional(),
        teamName: z.string().optional(),
        versionedAgentId: z.string().nullable(),
        messageCount: z.number().optional(),
        totalTokens: z.number().optional(),
        createdAt: z.date(),
        updatedAt: z.date().optional(),
        hasEscalation: z.boolean(),
        calledAgents: z.array(z.string()).optional(),
        userEmail: z.string(),
        isGeneral: z.boolean(),
        isDm: z.boolean().optional(),
        source: z.string().optional(),
        wasSent: z.boolean().optional(),
        subcategoryLabel: z.string().nullable().optional(),
      }),
    ),
    totalCount: z.number(),
    allThreads: z.array(
      z.object({
        _id: z.string(),
        teamId: z.string().optional(),
        teamName: z.string().optional(),
        createdAt: z.date(),
        calledAgents: z.array(z.string()).optional(),
        userEmail: z.string(),
        hasEscalation: z.boolean(),
        hasSubAgentCalls: z.boolean(),
        isGeneral: z.boolean(),
        isDm: z.boolean().optional(),
        source: z.string().optional(),
        messageCount: z.number(),
        totalTokens: z.number(),
        inputTokens: z.number(),
        subcategoryLabel: z.string().nullable().optional(),
      }),
    ),
    metrics: z.object({
      totalThreads: z.number(),
      escalatedToHuman: z.number(),
      resolutionRate: z.number(),
      avgResponseTime: z.number(),
      totalTokensUsed: z.number(),
      avgTokensPerThread: z.number(),
      totalSent: z.number(),
      sentPercentage: z.number(),
      slackDraftCount: z.number(),
      intercomDraftCount: z.number(),
      toolCallCounts: z.record(z.string(), z.number()),
      toolCallErrors: z.record(z.string(), z.number()),
      agentRoutingCounts: z.record(z.string(), z.number()),
      escalationCategories: z.record(z.string(), z.number()),
      subcategoryCounts: z.record(z.string(), z.number()),
      availableSubcategoryLabels: z.array(z.string()),
      avgMessagesBeforeEscalation: z.number(),
      avgMessagesPerThread: z.number(),
    }),
  }),
};
